module.exports = __webpack_public_path__ + "cfe1ee5a7707dba605c42caf9be9c7a7.gif";